import React, { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

interface PrizeLottieProps {
  className?: string;
}

export default function PrizeLottie({ className = '' }: PrizeLottieProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const lottieRef = useRef<DotLottie | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      lottieRef.current = new DotLottie({
        autoplay: true,
        loop: true,
        canvas: canvasRef.current,
        src: 'https://lottie.host/f3eb8aab-965a-45fb-b230-fcd282e3fa5c/HDYqoUWj05.lottie'
      });
    }

    return () => {
      if (lottieRef.current) {
        lottieRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className={`relative ${className}`}>
      <canvas 
        ref={canvasRef}
        className="max-w-[300px] mx-auto"
        width="300"
        height="300"
        style={{ width: '300px', height: '300px' }}
      />
    </div>
  );
}